import React from 'react'
import EditModal from '../edit-modal'
import BusyModal from '../../modals/busy'
import useCourse from '../../../hooks/use-course'
import { get } from 'lodash'

const MessageCourseScreen = ({
    subject,
    targetId,
    onHide = () => {},
}) => {
    const { isBusy, course } = useCourse({ id: targetId })

    if (isBusy) {
        return <BusyModal title='Retrieving enrollees information...' />
    }

    const enrollees = get(course, 'enrollees', [])

    console.log('enrollees:', enrollees)

    return (
        <EditModal
            recipients={enrollees}
            subject={subject}
            onHide={onHide}
        />
    )
}

export default MessageCourseScreen
